import { AlpineComponent } from 'alpinejs';

interface ShareModalOpenDetail {
	shareLink: string;
	shareCount: number;
}

interface ShareResponse {
	success: boolean;
	shareCount: number;
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

interface ShareModalData {
	open: boolean;
	shareLink: string;
	email: string;
	submitting: boolean;
	error: string | null;
	emailError: string | null;
	success: boolean;
	shareCount: number;
	openWith(detail: ShareModalOpenDetail): void;
	submit(): Promise<void>;
	close(): void;
}

const shareModal = (): AlpineComponent<ShareModalData> => ({
	open: false,
	shareLink: '',
	email: '',
	submitting: false,
	error: null,
	emailError: null,
	success: false,
	shareCount: 0,

	openWith({ shareLink, shareCount }) {
		this.shareLink = shareLink;
		this.email = '';
		this.error = null;
		this.emailError = null;
		this.success = false;
		this.shareCount = Math.max(this.shareCount, shareCount);
		this.open = true;

		const dialog = document.getElementById('share-dialog') as HTMLDialogElement;
		dialog?.showModal();
	},

	async submit() {
		if (this.submitting) return;

		this.error = null;
		this.emailError = EMAIL_PATTERN.test(this.email.trim())
			? null
			: 'Please enter a valid email address.';

		if (this.emailError) return;

		this.submitting = true;

		try {
			const rsp = await fetch(this.shareLink, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ email: this.email }),
			});

			if (!rsp.ok) {
				this.error = 'Something went wrong. Please try again.';
				return;
			}

			const data = (await rsp.json()) as ShareResponse;
			this.success = data.success;
			this.shareCount = data.shareCount;
		} catch {
			this.error = 'Something went wrong. Please try again.';
		} finally {
			this.submitting = false;
		}
	},

	close() {
		if (this.submitting) return;

		this.open = false;

		const dialog = document.getElementById('share-dialog') as HTMLDialogElement;
		dialog?.close();
	},
});

export default shareModal;
